import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Spinner from './Spinner';

// The btn/btn-* utility classes are defined in assets/sass/main.scss and
// already include each variant's hover styling.
const variantBase = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  tertiary: 'btn-tertiary'
};

ActionButton.propTypes = {
  variant: PropTypes.oneOf(Object.keys(variantBase)),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  loadingLabel: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node
};

export default function ActionButton(props) {
  const {
    variant = 'primary',
    disabled = false,
    loading = false,
    loadingLabel = 'Loading...',
    className = '',
    href,
    onClick,
    children,
    ...rest
  } = props;

  // The width utilities need ! because .btn sets w-fit and is defined after
  // the utility layer in main.scss, so it would win the cascade otherwise.
  const baseClass = classNames(
    'btn justify-center',
    variantBase[variant],
    '!w-full md:!w-auto min-h-12 md:min-h-10',
    className
  );
  const TheTag = href ? 'a' : 'button';
  const tagType = href ? undefined : 'button';

  if (loading) {
    return (
      <TheTag
        type={tagType}
        className={classNames(baseClass, 'opacity-70 cursor-wait')}
        disabled
        {...rest}
      >
        <Spinner />
        <span>{loadingLabel}</span>
      </TheTag>
    );
  }

  return (
    <TheTag
      type={tagType}
      className={classNames(
        baseClass,
        disabled && 'opacity-40 cursor-not-allowed pointer-events-none'
      )}
      disabled={disabled}
      href={href}
      onClick={onClick}
      {...rest}
    >
      {children}
    </TheTag>
  );
}
